import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=085c9222&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=085c9222&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085c9222",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Input: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Input.vue').default,FooterShare: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/FooterShare.vue').default,FooterButtonGroup: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/FooterButtonGroup.vue').default,Footer: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Footer.vue').default})
